import React, { useState, useEffect } from 'react';
import RichTextEditor from 'react-rte';
import PropTypes from 'prop-types';
import List from '../../common/List';
import Button from '../../common/Button';
import SimpleInput from '../../common/SimpleInput';
import styles from './DropshipProductCardInfo.module.scss';
import { toolbarConfig } from '../../../constants/rteToolbarConfig';

function DropshipProductCardInfo(props) {
  const [product, setProduct] = useState(props.product);
  const [editing, setEditing] = useState(false);
  const [extraDescription, setExtraDescription] = useState(
    RichTextEditor.createValueFromString(product.description_extra, 'html'),
  );

  const [currentImage, setCurrentImage] = useState(null);

  useEffect(() => {
    const image = product.square_images.length > 0 ? product.square_images[0] : null;
    setCurrentImage(image);
  }, [product]);

  const getImagesList = () => {
    if (!product.square_images.length) {
      return null;
    }

    return product.square_images.map((value) => (
      <div key={value} onClick={() => setCurrentImage(value)}>
        <img src={value} alt="Product" />
      </div>
    ));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    handleProductPropertyChange(name, value);
  };

  const handleChangeExtra = (value) => {
    setExtraDescription(value);
    handleProductPropertyChange('description_extra', value.toString('html'));
  };

  const handleProductPropertyChange = (key, value) => {
    setProduct({
      ...product,
      [key]: value,
    });
  };

  const reset = () => {
    setEditing(false);
    setExtraDescription(RichTextEditor.createValueFromString(product.description_extra, 'html'));
    setProduct(props.product);
  };

  const submit = () => {
    const descriptionBullets = product.description_bullets.filter((bullet) => bullet !== '');

    const data = {
      retailer_title: product.title,
      retailer_description: product.description,
      retailer_description_extra: product.description_extra,
      retailer_description_bullets: descriptionBullets,
    };

    setEditing(false);
    setProduct({
      ...product,
      description_bullets: descriptionBullets,
    });
    props.setProduct(data);
  };

  const hasDescriptionBullets = product.description_bullets && product.description_bullets.length;

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <div>
          <div className={styles.image}>
            <img src={currentImage} alt="Product" />
          </div>
          <div className={styles.imagesList}>{getImagesList()}</div>
        </div>

        <div>
          {editing ? (
            <div className={styles.edit}>
              <h4>Product name</h4>
              <SimpleInput name="title" value={product.title} onChange={handleChange} />

              <h4 className={styles.title}>Description</h4>
              <textarea name="description" value={product.description} onChange={handleChange} />

              <h4 className={styles.title}>Extra Description</h4>
              <RichTextEditor value={extraDescription} onChange={handleChangeExtra} toolbarConfig={toolbarConfig} />

              <h4 className={styles.title}>Description Bullets</h4>
              <List
                items={product.description_bullets}
                onChange={(value) => handleProductPropertyChange('description_bullets', value)}
                addText="Add Description Bullet"
              />

              <div className={styles.buttons}>
                <Button color="white" uppercase={false} text="Default" onClick={reset} />
                <Button uppercase={false} text="Approve" onClick={submit} />
              </div>
            </div>
          ) : (
            <div className={styles.read}>
              <h3 className={styles.title}>{product.title}</h3>
              <button className={styles.edit_button} onClick={() => setEditing(true)}>
                Edit
              </button>
              <hr />

              <h4 className={styles.title}>Description</h4>
              <p dangerouslySetInnerHTML={{ __html: product.description }} />
              <hr />

              <h4 className={styles.title}>Extra Description</h4>
              <p dangerouslySetInnerHTML={{ __html: product.description_extra }} />

              {hasDescriptionBullets ? (
                <>
                  <hr />
                  <h4 className={styles.title}>Description Bullets</h4>
                  <ul className={styles.bullets}>
                    {product.description_bullets.map((bullet, i) => (
                      <li key={i}>{bullet}</li>
                    ))}
                  </ul>
                </>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DropshipProductCardInfo;

DropshipProductCardInfo.propTypes = {
  product: PropTypes.shape({
    description_extra: PropTypes.string,
    description: PropTypes.string,
    square_images: PropTypes.array,
  }).isRequired,
  setProduct: PropTypes.func.isRequired,
};
